<div class="view_detail_dialog joi-dialog">
  <icon class="close" aria-label="Close" (click)="dialogRef.close()" matIcon="close"></icon>
  <dialog-title title="Session Information" [backgroundColor]="uiService.labelsByType.session.color"></dialog-title>
  <div mat-dialog-content>
    <div class="field sm"><b>{{data.session.title}}</b></div>
    <div class="field sm">{{data.session.start + ' - ' + data.session.end}}<span *ngIf="date">{{', ' + (date | date:'EEEE dd MMMM y')}}</span></div>
    <performers class="on-session" [performerIds]="data.session.performerIds" [displayType]="performerDisplayTypes.readOnly" [sessionId]="data.session.id"></performers>
    <static-sponsor-cards [showEmpty]="true" [sponsors]="sponsors" [sponsorIds]="data.session.sponsorIds"></static-sponsor-cards>

    <div class="field" *ngIf="data.program.title">
      <div class="name">PROGRAM</div>
      <div class="field sm">{{ data.program.title }}</div>
    </div>
    <div class="field" *ngIf="!!location">
      <div class="name">LOCATION</div>
      <div class="field sm">{{ location }}</div>
    </div>

    
    <div class="group">
      <div class="name">SESSION LABELS</div>
      <div class="not_found" *ngIf="(!data.session.labels || data.session.labels.length==0)">No labels</div>
      <label-tier [labels]="data.session.labels" [template]="currentEvent.session_labels"></label-tier>
    </div>

    <expanding-wrapper *ngIf="(session.id + 'info') as id"
      class="group info"
      [padded]="true"
      [title]="'Session Info'"
      [borderGreyOnCollapse]="true"
      [stackedMobile]="true"
    >
      <div class="header-right icon-holder">
        <icon-holder *ngIf="!!session.description" [icon]="'description18'"></icon-holder>
        <icon-holder *ngIf="!!session.publicLinks?.length" [icon]="'attachment'" [count]="session.publicLinks?.length"></icon-holder>
      </div>
      <div class="session-info">
        <title-icon [title]="'Session description'" titleIcon="description18" [small]="true"></title-icon>
        <input-editor *ngIf="!!session.description"
          [object]="session" 
          [prop]="'description'" 
          [disabled]="true"
        ></input-editor>
        <div class="empty-text" *ngIf="!session.description">No description</div>
        <title-icon class="public-links" [title]="'Public links'" titleIcon="link18" [small]="true"></title-icon>
        <file-handler class="public-links"
          [readfilesonly]="true"
          [type]="'Public'"
          [addText]="'ADD A LINK'"
          [hideByline]="true"
          [data]="{ files: session.publicLinks }"
        ><div class="empty-text" *ngIf="!session.publicLinks?.length">
          No public links in this session
        </div></file-handler>
      </div>
    </expanding-wrapper>

    <expanding-wrapper *ngIf="(session.id + 'briefNotes') as id"
      class="group"
      [title]="'Notes for Performer Brief'"
      [borderGreyOnCollapse]="true"
      [stackedMobile]="true"
      [padded]="true"
    >
      <icon-holder class="header-right" *ngIf="(session.presentationNotes || []).length as n" [count]="n"></icon-holder>
      <editable-notes
        [initClosed]="true"
        [noPadding]="true"
        [readOnly]="true"
        [notes]="[{ id: 'presentationNotes', title: 'Presentation notes for performer brief', items: session.presentationNotes, placeholder: 'No notes'}]"
      ></editable-notes>
    </expanding-wrapper>

    <expanding-wrapper *ngIf="(session.id + 'assets') as id"
      class="group"
      [title]="'Session Assets'"
      [borderGreyOnCollapse]="true"
      [stackedMobile]="true"
      [padded]="true"
    >
      <icon-holder class="header-right" *ngIf="((session.assetIds || []) | idsToItems:assets).length as n" [icon]="'assets'" [count]="n"></icon-holder>
      <assets
        [hideTitle]="true"
        [assetIds]="session.assetIds || []" 
        [readOnly]="true"
      ></assets>
    </expanding-wrapper>

    <expanding-wrapper class="notes" *ngIf="(session.id + 'notes') as id"
      class="group"
      [title]="'Staging Notes'"
      [borderGreyOnCollapse]="true"
      [stackedMobile]="true"
      [padded]="true"
    >
      <div class="header-right icon-holder">
        <icon-holder *ngIf="!!session.notes" [icon]="'description18'"></icon-holder>
        <icon-holder *ngIf="!!session.stagingItems?.length" [icon]="'event_information18'" [count]="session.stagingItems?.length"></icon-holder>
        <icon-holder *ngIf="!!session.files?.length" [icon]="'attachment'" [count]="session.files?.length"></icon-holder>
      </div>
      <div class="group">
        <div class="name">STAGING NOTES</div>
        <div class="not_found" *ngIf="!data.session.notes">No staging notes</div>
        <div class="value" *ngIf="data.session.notes" [innerHTML]="helpers.strWithBreak(data.session.notes)"></div>
      </div>

      <div class="group">
        <div class="name">STAGING ITEMS</div>
        <div class="not_found" *ngIf="!data.session.stagingItems?.length">No staging items</div>
        <public-informable
          [itemsInitClosed]="true"
          [singleSectionOnly]="true"
          [showEmptyItems]="true"
          [information]="[{ id: 'stagingItems', title: 'Staging items', items: data.session.stagingItems || [], placeholder: 'No staging items'}]"
        ></public-informable>
      </div>

      <div class="group">
        <div class="name">STAGING FILES</div>
        <div class="not_found" *ngIf="!data.session.files?.length">No staging files</div>
        <file-link *ngFor="let file of data.session.files"
          [file]="file"
          [onlyLink]="true"
        ></file-link>
      </div>
    </expanding-wrapper>

    <expanding-wrapper class="notes" *ngIf="(session.id + 'catering') as id"
      style="margin-top: 20px; display: block;"
      [title]="'Catering Notes'"
      [borderGreyOnCollapse]="true"
      [stackedMobile]="true"
      [padded]="true"
    >

      <div class="header-right icon-holder">
        <icon-holder *ngIf="!!session.cateringNotes" [icon]="'description18'"></icon-holder>
        <icon-holder *ngIf="!!session.cateringItems?.length" [icon]="'event_information18'" [count]="session.cateringItems?.length"></icon-holder>
        <icon-holder *ngIf="!!session.cateringFiles?.length" [icon]="'attachment'" [count]="session.cateringFiles?.length"></icon-holder>
      </div>
      <div class="group">
        <div class="name">CATERING NOTES</div>
        <div class="not_found" *ngIf="!data.session.cateringNotes">No catering notes</div>
        <div class="value" *ngIf="data.session.cateringNotes" [innerHTML]="helpers.strWithBreak(data.session.cateringNotes)"></div>
      </div>

      <div class="group">
        <div class="name">CATERING ITEMS</div>
        <div class="not_found" *ngIf="!data.session.cateringItems?.length">No catering items</div>
        <public-informable
          [itemsInitClosed]="true"
          [singleSectionOnly]="true"
          [showEmptyItems]="true"
          [information]="[{ id: 'cateringItems', title: 'Catering items', items: data.session.cateringItems || [], placeholder: 'No catering items'}]"
        ></public-informable>
      </div>

      <div class="group">
        <div class="name">CATERING FILES</div>
        <div class="not_found" *ngIf="!data.session.cateringFiles?.length">No catering files</div>
        <file-link *ngFor="let file of data.session.cateringFiles"
          [file]="file"
          [onlyLink]="true"
        ></file-link>
      </div>
    </expanding-wrapper>

    <expanding-wrapper class="group tags"
      [title]="'SESSION TAGS'"
      [padded]="true"
      [borderGreyOnCollapse]="true"
    >
      <div class="header-right icon-holder">
        <icon-holder *ngIf="!!tagPanelDatas[session.id]?.count" [count]="tagPanelDatas[session.id]?.count"></icon-holder>
      </div>
      <tag-panel-view 
        [tagData]="tagPanelDatas[session.id]"
        [readOnly]="true"
        [noHeaders]="false"
        [fromLogistics]="true"
        [performers]="currentEvent?.performers"
        [sponsors]="currentEvent?.sponsors"
        [exhibitors]="currentEvent?.exhibitors"
        [resources]="currentEvent?.resources"
        [workforce]="currentEvent?.workforce"
        [attendees]="currentEvent?.attendees"
      ></tag-panel-view>  
    </expanding-wrapper>

  </div>
</div>